import { ReactComponent as MagnifyingGlassSvg } from '../../../../assets/icons/MagnifyingGlass.svg';

import { createIconComponent } from './createIconComponent';

export const MagnifyingGlassIcon = createIconComponent(MagnifyingGlassSvg);
